module.exports = __webpack_public_path__ + "static/media/printerLabels.02b5ca63.svg";